import { render, staticRenderFns } from "./LeadRecord.vue?vue&type=template&id=62ae08f5&scoped=true&"
import script from "./LeadRecord.vue?vue&type=script&lang=js&"
export * from "./LeadRecord.vue?vue&type=script&lang=js&"
import style0 from "./LeadRecord.vue?vue&type=style&index=0&id=62ae08f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ae08f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62ae08f5')) {
      api.createRecord('62ae08f5', component.options)
    } else {
      api.reload('62ae08f5', component.options)
    }
    module.hot.accept("./LeadRecord.vue?vue&type=template&id=62ae08f5&scoped=true&", function () {
      api.rerender('62ae08f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/leads/LeadRecord.vue"
export default component.exports